// extracted by mini-css-extract-plugin
export var backgroundOregon = "oregon-timeline-module--backgroundOregon--H+34-";
export var chapterContainer = "oregon-timeline-module--chapterContainer--wgDtY";
export var chapter = "oregon-timeline-module--chapter--x7YfK";
export var chapterDate = "oregon-timeline-module--chapterDate--OUwAE";
export var legendContainer = "oregon-timeline-module--legendContainer--KuUm+";
export var legendItemContainer = "oregon-timeline-module--legendItemContainer--qCzi-";
export var categoryContent = "oregon-timeline-module--categoryContent--NZaRm";
export var legendIcon = "oregon-timeline-module--legendIcon--80JAb";
export var categoryTitle = "oregon-timeline-module--categoryTitle--Jd+G8";
export var categoryText = "oregon-timeline-module--categoryText--XGGV+";
export var fixedLegend = "oregon-timeline-module--fixedLegend--AYtsj";